import {SearchTermFilter} from '../search-term.filter';
import {DataSearchIndexFilter} from './index.filter';

export {DataSearchIndexFilter, SearchTermFilter}; // nosonar
export const DATA_SEARCH_FILTERS = [SearchTermFilter, DataSearchIndexFilter];
